import {type FC} from 'react'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import type {ImprovedHomepageDataProps} from '~/types'

type ArticleCardProps = {
  article: ImprovedHomepageDataProps['articles'][number]
  cardIndex: number
}

const ArticleCard: FC<ArticleCardProps> = ({article, cardIndex}) => {
  const reportWidgetClicked = useReportWidgetClick()

  const [cardRef] = useReportWidgetSeen({
    widget_name: 'improved-home-articles-card',
    widget_place: `${cardIndex + 1}`,
    variation: article.title,
  })

  const handleCardClick = () => {
    reportWidgetClicked({
      widget_name: 'improved-home-articles-card',
      widget_place: `${cardIndex + 1}`,
      variation: article.title,
    })
  }
  return (
    <a
      ref={cardRef}
      href={article.url}
      onClick={handleCardClick}
      className="flex h-[361px] flex-col items-center justify-between gap-2 rounded-[18px] bg-white p-6 shadow-[0px_2px_10px_0px_#00000026] tablet:h-[151px] tablet:w-full tablet:flex-row tablet:rounded-[13px] tablet:p-4"
      aria-label={`view ${article.title}`}
      target="_blank"
      rel="noreferrer"
    >
      <div className="flex h-[145px] w-full shrink-0 items-center justify-center rounded-[10px] tablet:h-[119px] tablet:w-[136px] tablet:rounded-lg">
        <img
          src={article.image}
          alt={article.title}
          className="h-[145px] w-[296px] object-cover tablet:h-[119px] tablet:w-[136px]"
          loading="lazy"
        />
      </div>
      <div className="flex h-full flex-col justify-between">
        <span className="text-base font-light text-[#828282] tablet:text-[13px]">{article.article}</span>

        <span className="line-clamp-2 text-2xl font-semibold leading-7 text-black tablet:text-lg tablet:leading-5">
          {article.title}
        </span>
        <p className="line-clamp-3 font-light leading-tight text-[#4F4F4F] tablet:text-xs tablet:leading-[15px]">
          {article.description}
        </p>
      </div>
    </a>
  )
}

export default ArticleCard
